<template>
    <span>
        <span
            v-if="datePanelLabel && !showInput"
            v-show="datePanelLabel.labels[0].type === 'year' || currentView === 'date'"
            :class="[datePrefixCls + '-header-label']"
            @click="handleClick">{{ datePanelLabel.labels[0].label }}</span>
            <template  v-if="datePanelLabel && showInput">
                <InputNumber ref="yearInput" :max="9999" :class="[datePrefixCls + '-input-year']" size="small" v-model.number="year" style="width:50px;" @on-enter="submitYear" @on-blur="submitYear"></InputNumber>
                <span :class="[datePrefixCls + '-year-unit']">{{t('i.datepicker.year')}}</span>
            </template>

        <template v-if="datePanelLabel && currentView === 'date'">{{ datePanelLabel.separator }}</template>
        <span
            v-if="datePanelLabel"
            v-show="datePanelLabel.labels[1].type === 'year' || currentView === 'date'"
            :class="[datePrefixCls + '-header-label']"
            @click="datePanelLabel.labels[1].handler">{{ datePanelLabel.labels[1].label }}</span>
    </span>
</template>

<script>
import Locale from '../../../../mixins/locale';

export default {
    props: {
        datePanelLabel: Object,
        currentView: String,
        datePrefixCls: String,
        editableYear: Boolean
    },

    mixins: [Locale],

    data() {
        return {
            showInput: false,
            year: undefined
        };
    },

    watch: {
        currentView(newVal) {
            if (newVal !=='year') {
                this.showInput = false;
            }
        }
    },

    methods: {
        handleClick(e) {
            this.datePanelLabel.labels[0].handler(e);
            if (this.currentView==='year') {
                this.showInput = true;
                this.year = Number(this.datePanelLabel.labels[0].label.replace(this.t('i.datepicker.year'), ''));
                this.$nextTick(() => {
                    this.$refs.yearInput.$el.querySelector('input').focus();
                });
            }
        },

        submitYear(e) {
            // 防止组件有transfer属性时。blur事件提取触发
            if (this._disabelBlur) {
                return;
            }
            if (this.currentView==='year') {
                const year = new Date(this.year, 0, 1);
                this.$emit('on-pick', year);
                this.$emit('on-pick-click');
                this.showInput = false;
            }
        },

        // 绑定事件
        attachMousemoveEvent() {
            window.addEventListener('mousemove', this.handleMove);
            this.$once('hook:beforeDestroy', () => {
                window.removeEventListener('mousemove', this.handleMove);
            });
        },

        handleMove(e) {
            if (e.target.tagName === 'EM') {
                this._disabelBlur = true;
            } else {
                this._disabelBlur = false;
            }
        }
   },

   mounted () {
       this.attachMousemoveEvent();
   }
};
</script>



// WEBPACK FOOTER //
// src/components/date-picker/panel/Date/date-panel-label.vue